<template lang="pug">
	.publisher-settings
		.page-center-content(v-if="publisher")
			.caption-area
				.back(v-if="Layout.pageOptions.backPage")
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="Layout.setPage.apply(Layout, Layout.pageOptions.backPage)")
						.icon.fa.fa-angle-double-left
				.caption(:class="{'back-exist': Layout.pageOptions.backPage}") {{publisher.title}} Settings
				.logo(@click="selectPublisher(publisher.id)")
					img(:src="`/Images/Icons/Publishers/${publisher.codename || publisher.id}.png?v=${publisher['last_activity_time'] || publisher['create_date']}`" :alt="publisher.title")
			.settings-groups-area
				.settings-section
					.settings-group
						.form-group
							label Name
							input.form-control(type="text" :value="publisher.title" @input="saveTitle($event.target.value)")
					.settings-group
						.form-group
							label Logotype
							br
							button.btn.btn-secondary(type="button" @click="replaceLogo")
								.icon.fa.fa-upload
								span &nbsp;&nbsp;Upload new png logotype
				.settings-section.amazon-s3
					label.no-margin Amazon S3
					.description.text-muted
						span Create a new Amazon S3 credentials for {{Metadata.Config['dashboard-page-title'] || ''}} to allow automatic upload your creatives code to CDN
					.columns-3
						.column
							.form-group
								label Access key id
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.accessKeyId')" @input="saveOption('AmazonS3', {'accessKeyId': $event.target.value})")
						.column
							.form-group
								label Secret access key
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.secretAccessKey')" @input="saveOption('AmazonS3', {'secretAccessKey': $event.target.value})")
						.column
							.form-group
								label Bucket name
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.bucketName')" @input="saveOption('AmazonS3', {'bucketName': $event.target.value})")
					.columns-3
						.column
							.form-group
								label Bucket region
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.bucketRegion')" @input="saveOption('AmazonS3', {'bucketRegion': $event.target.value})")
						.column
							.form-group
								label Bucket root path
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.rootPath')" @input="saveOption('AmazonS3', {'rootPath': $event.target.value})")
						.column
							.form-group
								label CDN url
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.cdnUrl')" @input="saveOption('AmazonS3', {'cdnUrl': $event.target.value})")
					.columns-3
						.column
							.form-group.inline.no-margin
								label Include preview
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="!!_.get(publisher.options, 'AmazonS3.preview')" @change="saveOption('AmazonS3', {'preview': $event.target.checked})")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
				.settings-section.releases
					label Playable releases
					.columns-3
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in playableReleases[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in playableReleases[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in playableReleases[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
				.settings-section.releases
					label Banner releases
					.columns-3
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in bannerReleases[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in bannerReleases[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in bannerReleases[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
				.settings-section.amazon-s3
					label Main menu
					.columns-3
						.column
							.form-group.inline.no-margin
								label Playables
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'mainMenu.playables') !== false" @change="saveOption('mainMenu', {'playables': $event.target.checked})")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="Metadata.Config['feature-banners']")
							.form-group.inline.no-margin
								label Banners
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'mainMenu.banners') !== false" @change="saveOption('mainMenu', {'banners': $event.target.checked})")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="Metadata.Config['feature-end-cards']")
							.form-group.inline.no-margin
								label End Cards
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'mainMenu.endCards') !== false" @change="saveOption('mainMenu', {'endCards': $event.target.checked})")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
					label.main-menu-markers Show folders for the markers
					.description.text-muted(v-if="!projectMarkers[0].length")
						span There are no project markers created so far
					.columns-3(v-if="projectMarkers[0].length > 0")
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="_.get(publisher.options, `mainMenu.markers.${marker}`)" v-on:change="saveOption('mainMenu', {markers: {[marker]: $event.target.checked}})")
									|{{marker}}
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="_.get(publisher.options, `mainMenu.markers.${marker}`)" v-on:change="saveOption('mainMenu', {markers: {[marker]: $event.target.checked}})")
									|{{marker}}
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="_.get(publisher.options, `mainMenu.markers.${marker}`)" v-on:change="saveOption('mainMenu', {markers: {[marker]: $event.target.checked}})")
									|{{marker}}
				.settings-section.amazon-s3
					label Project list panel
					.columns-3
						.column
							.form-group
								label Order field
								select.custom-select.custom-select-sm(@change="saveOption('UI', {'projectPlaneIconsSort': {type: $event.target.value, order: _.get(publisher.options, 'UI.projectPlaneIconsSort.order') || 'desc'}})")
									option(:selected="_.get(publisher.options, 'UI.projectPlaneIconsSort.type') === 'create_date' || !_.get(publisher.options, 'UI.projectPlaneIconsSort.type')" value="create_date") Date of creation
									option(:selected="_.get(publisher.options, 'UI.projectPlaneIconsSort.type') === 'title'" value="title") Title
						.column
							.form-group
								label Order direction
								select.custom-select.custom-select-sm(@change="saveOption('UI', {'projectPlaneIconsSort': {type: _.get(publisher.options, 'UI.projectPlaneIconsSort.type') || 'create_date', order: $event.target.value}})")
									option(:selected="_.get(publisher.options, 'UI.projectPlaneIconsSort.order') === 'asc'" value="asc") Ascending
									option(:selected="_.get(publisher.options, 'UI.projectPlaneIconsSort.order') === 'desc' || !_.get(publisher.options, 'UI.projectPlaneIconsSort.order')" value="desc") Descending
						.column
					//label Show projects with specified markers
					//.description.text-muted(v-if="!projectMarkers[0].length")
						span There are no project markers created so far
					//.columns-3(v-if="projectMarkers[0].length > 0")
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!publisher.options.projectMarkers[marker]['hideInProjectList']" v-on:change="changeProjectMarkerProjectListViewability(marker, $event.target.checked)")
									|{{marker}}
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!publisher.options.projectMarkers[marker]['hideInProjectList']" v-on:change="changeProjectMarkerProjectListViewability(marker, $event.target.checked)")
									|{{marker}}
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!publisher.options.projectMarkers[marker]['hideInProjectList']" v-on:change="changeProjectMarkerProjectListViewability(marker, $event.target.checked)")
									|{{marker}}
				.settings-section.project-markers
					.columns-2.caption
						.column
							label Project Markers
						.row.content-left
							input.form-control.new-marker(type="text" v-model="newProjectMarkerName")
							button.btn.btn-sm.btn-ghost-secondary(type="submit" @click="addProjectMarker()")
								i.fa.fa-plus
								| &nbsp;&nbsp;Add marker
					.description.text-muted
						span You can create a list of markers (just use any text), specify behavior for each marker and assign it to any project on the project settings screen. In this case you will have the possibility to show / hide projects with specific marker, or show it in separated folder in main menu.
					.description.text-muted(v-if="!projectMarkers[0].length")
						span There are no project markers created so far
					.columns-3(v-if="projectMarkers[0].length > 0")
						.column
							.marker(v-for="marker in projectMarkers[0]")
								label.form-check-label {{marker}}
									i.fa.fa-remove(@click="removeProjectMarker(marker)")
						.column
							.marker(v-for="marker in projectMarkers[1]")
								label.form-check-label {{marker}}
									i.fa.fa-remove(@click="removeProjectMarker(marker)")
						.column
							.marker(v-for="marker in projectMarkers[2]")
								label.form-check-label {{marker}}
									i.fa.fa-remove(@click="removeProjectMarker(marker)")
</template>

<script>
	import Screen 				from './../../mixins/screen'

	import { Metadata } 		from './../../services/Metadata'
	import { Layout } 			from './../../services/Layout'
	import { Publisher } 		from './../../services/Publisher'

	import SetupSettings 		from "./../../settings/settings.json";

	export default {
		name: "PublisherSettings",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Publisher Data Changed", "Layout Page Showed:publisher-settings", "Metadata Loaded"]
		},
		data() {

			this.publisher = null;

			this.playableReleases = [[], [], []];
			this.bannerReleases = [[], [], []];
			this.projectMarkers = [[], [], []];

			return {
				showed: true,
				publisherId: null,
				newProjectMarkerName: ''
			}

		},
		methods: {
			collectData() {

				if (Layout.page === 'publisher-settings' && Layout.pageOptions?.publisherId) {

					this.publisherId = Layout.pageOptions.publisherId;

				} else if (Publisher.SelectedPublisher) {

					this.publisherId = Publisher.SelectedPublisher.id;

				} else {

					this.publisherId = null;

				}

				this.publisher = Publisher.Publishers[this.publisherId];

				let releases = _.orderBy(_.filter(_.values(Metadata.Releases), release => release.enabled && release.type === 'playable'), 'priority');
				let partLength = Math.ceil(releases.length / 3);

				this.playableReleases[0] = releases.slice(0, partLength);
				this.playableReleases[1] = releases.slice(partLength, partLength * 2);
				this.playableReleases[2] = releases.slice(partLength * 2);

				releases = _.orderBy(_.filter(_.values(Metadata.Releases), release => release.enabled && release.type === 'banner'), 'priority');
				partLength = Math.ceil(releases.length / 3);

				this.bannerReleases[0] = releases.slice(0, partLength);
				this.bannerReleases[1] = releases.slice(partLength, partLength * 2);
				this.bannerReleases[2] = releases.slice(partLength * 2);

				if (this.publisher) {

					let projectMarkers = _.keys(this.publisher.options.projectMarkers);
					partLength = Math.ceil(projectMarkers.length / 3);

					this.projectMarkers[0] = projectMarkers.slice(0, partLength);
					this.projectMarkers[1] = projectMarkers.slice(partLength, partLength * 2);
					this.projectMarkers[2] = projectMarkers.slice(partLength * 2);

				}

			},
			saveTitle(title) {

				Server.sendWithTimeout({
					UpdatePublisherTitle: {
						publisherId: this.publisher.id,
						title
					}
				});

			},
			replaceLogo() {

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "image/png";

				input.addEventListener('change', e => {

					let file = e.target.files[0];

					let formData = new FormData();

					formData.append("publisherId", this.publisherId);
					formData.append("file", file);

					let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/publisher/uploadLogo';
					if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/publisher/uploadLogo';

					let xhr = new XMLHttpRequest();

					xhr.withCredentials = true;

					xhr.open("POST", url);

					xhr.upload.onprogress = function(e) {
						if (e.lengthComputable) {
							this.uploadProgress = e.loaded / e.total;
						}
					};

					xhr.upload.onloadstart = function(e) {
						this.isUploading = true;
					};

					xhr.upload.onloadend = function(e) {
						this.isUploading = false;
					};

					xhr.send(formData);

					document.body.removeChild(input);

				});

				input.click();

			},
			isReleaseActive(release) {

				if (!release['enabled']) return false;

				if (release.codename in (this.publisher.options['Releases'] || {})) return this.publisher.options['Releases'][release.codename];

				return release.options["enabledByDefault"];

			},
			changeReleaseStatus(release, isActive) {

				if (!this.publisher.options["Releases"]) this.publisher.options["Releases"] = {};
				this.publisher.options["Releases"][release.codename] = !!isActive;

				Server.sendWithTimeout({
					UpdatePublisherOptions: {
						publisherId: this.publisher.id,
						Releases: _.clone(this.publisher.options["Releases"] || {})
					}
				});

			},
			saveOption(optionsName, newData) {

				if (!this.publisher.options[optionsName]) this.publisher.options[optionsName] = {};

				_.merge(this.publisher.options[optionsName], newData);

				Server.sendWithTimeout({
					UpdatePublisherOptions: {
						publisherId: this.publisher.id,
						[optionsName]: this.publisher.options[optionsName]
					}
				}, null, 1000);

			},
			selectPublisher(publisherId) {

				Publisher.selectPublisher(publisherId);
				Layout.setPage('playables');

			},
			addProjectMarker() {

				Server.sendToServer({
					AddProjectMarkerToPublisher: {
						publisherId: this.publisher.id,
						projectMarkerName: this.newProjectMarkerName
					}
				});

			},
			removeProjectMarker(projectMarkerName) {

				Server.sendToServer({
					RemoveProjectMarkerFromPublisher: {
						publisherId: this.publisher.id,
						projectMarkerName: projectMarkerName
					}
				});

			},
			changeProjectMarkerProjectListViewability(projectMarkerName, showInProjectList) {

				Server.sendToServer({
					SetPublisherProjectMarkerOption: {
						publisherId: this.publisher.id,
						projectMarkerName: projectMarkerName,
						optionName: 'hideInProjectList',
						optionValue: !showInProjectList
					}
				});

			}
		}
	}
</script>

<style lang="sass" scoped>

	.publisher-settings
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1000px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: start
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

				.back
					display: flex
					align-items: center
					justify-content: center
					padding: 0.2rem 1rem

					button
						width: 30px
						height: 30px

				.caption
					padding: 1rem

				.caption.back-exist
					padding: 1rem 0

				.logo
					display: flex
					margin-left: auto
					padding: 10px
					cursor: pointer

					img
						display: flex
						height: 33px
						margin: 0 10px
						align-items: center
						color: #fff
						padding-left: 10px
						text-transform: uppercase

			.settings-groups-area
				display: flex
				flex-direction: column
				flex-wrap: nowrap

				.settings-section
					display: flex
					flex-direction: row
					flex-wrap: wrap
					margin: 1rem
					margin-bottom: 0
					border-bottom: 1px solid rgba(0,0,0,0.2)
					padding-bottom: 1rem

					.settings-group
						padding: 0 1rem
						width: 50%

						.form-group
							margin-bottom: 1rem

				.settings-section.amazon-s3
					flex-direction: column
					flex-wrap: nowrap
					padding: 0 1rem
					padding-bottom: 1rem

					> label
						margin-bottom: 20px

					> label.no-margin
						margin-bottom: 0

					.description
						margin-bottom: 20px

				.settings-section.releases
					flex-direction: column
					flex-wrap: nowrap
					padding: 0 1rem
					padding-bottom: 1rem

					> label
						margin-bottom: 20px

				.settings-section.project-markers
					flex-direction: column
					flex-wrap: nowrap
					padding: 0 1rem
					padding-bottom: 1rem

					> label
						margin-bottom: 0

					.description
						margin-bottom: 20px

					.caption
						margin-bottom: 5px

						input
							width: 150px
							height: calc(0.75rem + 0.75rem + 8px)
							margin-right: 10px
							padding: 0.25rem 0.5rem

						button
							width: auto

					i.fa.fa-remove
						display: none
						cursor: pointer
						margin-left: 5px

					.marker:hover

						i.fa.fa-remove
							display: inline

				.columns-2
					display: flex
					flex-direction: row
					flex-wrap: nowrap

					.column
						display: flex
						flex-direction: column
						width: 50%
						padding-right: 1rem

					.row
						display: flex
						flex-direction: row
						width: 50%
						padding-right: 1rem

				.columns-3
					display: flex
					flex-direction: row
					flex-wrap: nowrap

					.column
						display: flex
						flex-direction: column
						width: 33%
						padding-right: 1rem

						.form-group
							display: flex
							flex-direction: column
							align-items: start
							justify-content: start

							label.switch
								margin-left: 10px

						.form-group.inline
							flex-direction: row
							align-items: center

						.form-group.no-margin
							margin-bottom: 0

			.main-menu-markers
				margin-top: 20px


		label
			margin-bottom: 0.5rem

		input[type="text"]
			width: 100%
			height: calc(1.5em + 0.75rem + 2px)
			padding: 0.375rem 0.75rem
			font-size: 0.875rem
			font-weight: 400
			line-height: 1.5
			color: rgba(255, 255, 255, 0.87)
			background-color: rgba(255, 255, 255, 0.05)
			border: 1px solid rgba(255, 255, 255, 0.09)
			border-radius: 0.25rem
			transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out

		.multi-select-checkbox
			margin-bottom: 10px

			label
				margin-bottom: 0
				cursor: pointer

				.form-check-input
					top: -1px

				input
					cursor: pointer

		.custom-select
			width: auto

		.content-left
			justify-content: end

	@media screen and (max-width: 600px)

		.publisher-settings

			.page-center-content

				.settings-groups-area

					.settings-group
						width: 100%

</style>

